module.exports = __webpack_public_path__ + "img/2e.11ae8742.jpg";